import getPopularPosts, { fetchPosts }  from './getPopularPosts';
import getPopularCategoryPosts from './getPopularCategoryPosts';
import getTaxPostsByTermID from './getTaxPostsByTermID';
import initializeRecentPostsTrigger from './initializeRecentPostsTrigger';
import indexItemMarkup from './indexItemMarkup';
import loadMorePopularPosts from './loadMorePopularPosts';
import './popularNow';

/**
 * Setup a global Parsely helper. 
 */
adw.parsely = {
	fetchPosts,
	getPopularPosts,
	getPopularCategoryPosts,
	getTaxPostsByTermID,
	initializeRecentPostsTrigger,
	indexItemMarkup,
	loadMorePopularPosts
};